
// Multilingual content structure for Fan Sale steps
export const fanSaleContent = {
  hero: {
    title: {
      en: "Fred again..",
      es: "Fred again..",
      ca: "Fred again.."
    },
    description: {
      en: "Everything you need to know about accessing, validating, and purchasing tickets for the Madrid show.",
      es: "Todo lo que necesitas saber sobre acceder, validar y comprar entradas para el evento de Madrid.",
      ca: "Tot el que necessites saber sobre accedir, validar i comprar entrades per l'esdeveniment de Madrid."
    }
  },
  steps: [
    // {
    //   id: "got-code",
    //   number: "01",
    //   title: {
    //     en: "You've Got the Code",
    //     es: "Ya Tienes el Código",
    //     ca: "Ja Tens el Codi"
    //   },
    //   description: {
    //     en: "Getting started with registration for the sale",
    //     es: "Comenzando el registro a la venta",
    //     ca: "Començant el registre a la venda"
    //   },
    //   content: {
    //     intro: {
    //       en: "You should have received an email with a special link to register for the Fred again.. event sale in Madrid. Having the complete registration will give you access to the sale.",
    //       es: "Deberías haber recibido un email con un enlace especial para registrarte a la venta del evento de Fred again.. en Madrid. Tener el registro completo te dará acceso a la venta.",
    //       ca: "Hauries d'haver rebut un email amb un enllaç especial per registrar-te a la venda de l'esdeveniment de Fred again.. a Madrid. Tenir el registre complet et donarà accés a la venda."
    //     },
    //     points: {
    //       en: [
    //         "This link contains your unique access code",
    //         "Click the link to access registration in AccessTicket",
    //         "If you don't have AccessTicket, the link will open the store to download it",
    //         "You will need to create an account - please use the same email where you received this email",
    //       ],
    //       es: [
    //         "Este enlace contiene tu código de acceso único",
    //         "Haz clic en el enlace para acceder al registro en AccessTicket",
    //         "Si no tienes AccessTicket, el enlace abrirá la tienda para descargarlo",
    //         "Necesitarás crear una cuenta - por favor usa el mismo email donde recibiste este correo",
    //       ],
    //       ca: [
    //         "Aquest enllaç conté el teu codi d'accés únic",
    //         "Fes clic a l'enllaç per accedir al registre a AccessTicket",
    //         "Si no tens AccessTicket, l'enllaç obrirà la botiga per descarregar-lo",
    //         "Necessitaràs crear un compte - si us plau usa el mateix email on vas rebre aquest correu",
    //       ]
    //     }
    //   },
    //   image: "https://assets.primaverasound.com/psweb/9iasqbq1wy3m0am4a63t_1759934745730.png",
    // },
    // {
    //   id: "register",
    //   number: "02",
    //   title: {
    //     en: "Register for the Sale",
    //     es: "Regístrate a la venta",
    //     ca: "Registra't a la venda"
    //   },
    //   description: {
    //     en: "Required step to access the sale",
    //     es: "Paso requerido para acceder a la venta",
    //     ca: "Pas requerit per accedir a la venda"
    //   },
    //   content: {
    //     intro: {
    //       en: "IMPORTANT: Only correctly completed registrations will be eligible to access the sale on October 14th.",
    //       es: "IMPORTANTE: Solo los registros completados correctamente serán elegibles para acceder a la venta el 14 de octubre.",
    //       ca: "IMPORTANT: Només els registres completats correctament seran elegibles per accedir a la venda el 14 d'octubre."
    //     },
    //     points: {
    //       en: [
    //         "Full Name (First and Last Name)",
    //         "Email Address",
    //         "Age",
    //         "Country",
    //         "Take a clear selfie photo with good lighting and your face clearly visible",
    //         "This helps prevent fraud and ensures ticket security",
    //         "Once validated correctly, your registration will turn green indicating everything is fine",
    //       ],
    //       es: [
    //         "Nombre Completo (Nombre y Apellidos)",
    //         "Dirección de Email",
    //         "Edad",
    //         "País",
    //         "Toma una foto selfie clara con buena iluminación y que tu cara sea claramente visible",
    //         "Esto ayuda a prevenir fraude y asegura la seguridad de las entradas",
    //         "Una vez validado correctamente, tu registro se pondrá verde indicándote que todo está bien",
    //       ],
    //       ca: [
    //         "Nom Complet (Nom i Cognoms)",
    //         "Adreça d'Email",
    //         "Edat",
    //         "País",
    //         "Fes una foto selfie clara amb bona il·luminació i que la teva cara sigui clarament visible",
    //         "Això ajuda a prevenir frau i assegura la seguretat de les entrades",
    //         "Un cop validat correctament, el teu registre es posarà verd indicant-te que tot està bé",
    //       ]
    //     },
    //     tip: {
    //       en: "Complete your registration as soon as possible - don't wait until sale day!",
    //       es: "¡Completa tu registro lo antes posible - no esperes hasta el día de la venta!",
    //       ca: "Completa el teu registre tan aviat com sigui possible - no esperis fins al dia de la venda!"
    //     }
    //   },
    //   image: "https://assets.primaverasound.com/psweb/j7v77yc22unymn6ighhn_1760085883984.png"
    // },
    // {
    //   id: "payment",
    //   number: "03",
    //   title: {
    //     en: "Add Your Payment Method",
    //     es: "Añade tu Método de Pago",
    //     ca: "Afegeix el teu Mètode de Pagament"
    //   },
    //   description: {
    //     en: "Highly recommended before sale day",
    //     es: "Altamente recomendado antes del día de la venta",
    //     ca: "Altament recomanat abans del dia de la venda"
    //   },
    //   content: {
    //     intro: {
    //       en: "If you are not using Apple Pay or Google Pay, we recommend that you get ready for sale day by setting up payment in advance.",
    //       es: "Si no estás usando Apple Pay o Google Pay, te recomendamos que te prepares para el día de la venta configurando el pago por adelantado.",
    //       ca: "Si no estàs utilitzant Apple Pay o Google Pay, et recomanem que et preparis per al dia de la venda configurant el pagament per endavant."
    //     },
    //     points: {
    //       en: [
    //         "Open AccessTicket app",
    //         "Go to Profile Section",
    //         'Select "Payment Methods"',
    //         "Add your preferred payment method",
    //       ],
    //       es: [
    //         "Abre la app AccessTicket",
    //         "Ve a la Sección de Perfil",
    //         'Selecciona "Métodos de Pago"',
    //         "Añade tu método de pago preferido",
    //       ],
    //       ca: [
    //         "Obre l'app AccessTicket",
    //         "Ves a la Secció de Perfil",
    //         'Selecciona "Mètodes de Pagament"',
    //         "Afegeix el teu mètode de pagament preferit",
    //       ]
    //     },
    //     tip: {
    //       en: "Sales can be very fast-paced, and having your payment ready saves precious time!",
    //       es: "¡Las ventas pueden ser muy rápidas, y tener tu pago listo te ahorra tiempo valioso!",
    //       ca: "Les vendes poden ser molt ràpides, i tenir el teu pagament llest t'estalvia temps valuós!"
    //     }
    //   },
    //   image: "https://assets.primaverasound.com/psweb/yn0hyqmxjdhp3n8gwr0h_1759935112864.png"
    // },
    // {
    //   id: "purchase",
    //   number: "04",
    //   title: {
    //     en: "Sale Day - How to Purchase",
    //     es: "Día de Venta - Cómo Comprar",
    //     ca: "Dia de Venda - Com Comprar"
    //   },
    //   description: {
    //     en: "Step-by-step purchasing process",
    //     es: "Proceso de compra paso a paso",
    //     ca: "Procés de compra pas a pas"
    //   },
    //   content: {
    //     intro: {
    //       en: "When the sale opens, follow these steps to purchase your tickets:",
    //       es: "Cuando se abra la venta, sigue estos pasos para comprar tus entradas:",
    //       ca: "Quan s'obri la venda, segueix aquests passos per comprar les teves entrades:"
    //     },
    //     points: {
    //       en: [
    //         "Open AccessTicket app",
    //         "Navigate to the event",
    //         "Select your tickets",
    //         "Choose quantity and complete payment",
    //         "Your tickets will appear in the events section"
    //       ],
    //       es: [
    //         "Abre la app AccessTicket",
    //         "Navega al evento",
    //         "Selecciona tus entradas",
    //         "Elige cantidad y completa el pago",
    //         "Tus entradas aparecerán sección eventos"
    //       ],
    //       ca: [
    //         "Obre l'app AccessTicket",
    //         "Navega a l'esdeveniment",
    //         "Selecciona les teves entrades",
    //         "Tria quantitat i completa el pagament",
    //         "Les teves entrades apareixeran a la secció esdeveniments"
    //       ]
    //     }
    //   },
    //   image: 'https://assets.primaverasound.com/psweb/hsr8pvy1a6wgb0wdozq7_1760084571592.png'
    // },
    {
      id: "practical-info",
      number: "01",
      title: {
        en: "Practical information",
        es: "Información práctica",
        ca: "Informació pràctica"
      },
      description: {
        en: "Essential event details",
        es: "Detalles esenciales del evento",
        ca: "Detalls essencials de l'esdeveniment"
      },
      content: {
        intro: {
          en: "Everything you need to know about the event logistics and venue information.",
          es: "Todo lo que necesitas saber sobre la logística del evento e información del recinto.",
          ca: "Tot el que necessites saber sobre la logística de l'esdeveniment i informació del recinte."
        },
        sections: [
          {
            title: {
              en: "When will the event take place?",
              es: "¿Cuándo tendrá lugar el evento?",
              ca: "Quan tindrà lloc l'esdeveniment?"
            },
            points: {
              en: ["17th October"],
              es: ["El 17 de Octubre"],
              ca: ["El 17 d'Octubre"]
            }
          },
          {
            title: {
              en: "What is the exact location?",
              es: "¿Cuál es la localización exacta?",
              ca: "Quina és la localització exacta?"
            },
            points: {
              en: [
                "IFEMA (Hall 6)",
                "Av. del Partenón, 5H, Barajas, 28042",
                "Madrid"
              ],
              es: [
                "IFEMA (Pabellón 6)",
                "Av. del Partenón, 5H, Barajas, 28042",
                "Madrid"
              ],
              ca: [
                "IFEMA (Pavelló 6)",
                "Av. del Partenón, 5H, Barajas, 28042",
                "Madrid"
              ]
            }
          },
          {
            title: {
              en: "What are the opening hours?",
              es: "¿Cuál es el horario?",
              ca: "Quin és l'horari?"
            },
            points: {
              en: ["From 10:30 p.m. to 6:00 a.m."],
              es: ["De 22:30h a 6:00h"],
              ca: ["De 22:30h a 6:00h"]
            }
          },
          {
            title: {
              en: "Until when can I access the event?",
              es: "¿Hasta cuándo puedo acceder al evento?",
              ca: "Fins quan puc accedir a l'esdeveniment?"
            },
            points: {
              en: ["Until 5:00 a.m., one hour before the event ends"],
              es: ["Hasta las 5:00h, una hora antes de que finalice el evento"],
              ca: ["Fins a les 5:00h, una hora abans que finalitzi l'esdeveniment"]
            }
          },
          {
            title: {
              en: "Is there a minimum age requirement to attend?",
              es: "¿Hay una edad mínima para poder acceder?",
              ca: "Hi ha una edat mínima per poder accedir?"
            },
            points: {
              en: ["Yes, the event is for people over 18 years of age"],
              es: ["Sí, el evento es para mayores de 18 años"],
              ca: ["Sí, l'esdeveniment és per a majors de 18 anys"]
            }
          },
          {
            title: {
              en: "I have purchased more than one ticket. What do I need to do to access the event?",
              es: "He comprado más de una entrada. ¿Qué tengo que hacer para acceder?",
              ca: "He comprat més d'una entrada. Què he de fer per accedir?"
            },
            points: {
              en: [
                "Each ticket must be validated. You will need to provide the details of each person attending for each ticket: name, email address, age, country and selfie.",
                "Only people with fully validated tickets will be granted access to the venue."
              ],
              es: [
                "Cada entrada requiere su validación. Necesitarás proporcionar datos de acompañante para cada entrada: Nombre, Email, Edad, País y Selfie.",
                "Solo las entradas con validación completa pueden acceder al recinto."
              ],
              ca: [
                "Cada entrada requereix la seva validació. Necessitaràs proporcionar dades d'acompanyant per a cada entrada: Nom, Email, Edat, País i Selfie.",
                "Només les entrades amb validació completa poden accedir al recinte."
              ]
            }
          },
          {
            title: {
              en: "Are tickets transferable?",
              es: "¿Las entradas son transferibles?",
              ca: "Les entrades són transferibles?"
            },
            points: {
              en: ["No, ticket transfers are not permitted for this event."],
              es: ["No, la transferencia de entradas no está habilitada para este evento."],
              ca: ["No, la transferència d'entrades no està habilitada per a aquest esdeveniment."]
            }
          },
          {
            title: {
              en: "Can I gain access with a screenshot?",
              es: "¿Podré acceder con una captura de pantalla?",
              ca: "Podré accedir amb una captura de pantalla?"
            },
            points: {
              en: ["No, QR codes are dynamic, so a screenshot will not allow you to access the event."],
              es: ["No, los QR son dinámicos por lo que una captura de pantalla no te servirá para acceder al evento."],
              ca: ["No, els QR són dinàmics per la qual cosa una captura de pantalla no et servirà per accedir a l'esdeveniment."]
            }
          },
          {
            title: {
              en: "Are there accessible tickets?",
              es: "¿Hay entradas accesibles?",
              ca: "Hi ha entrades accessibles?"
            },
            points: {
              en: ["Yes, there are a limited number of PMR tickets available for wheelchair users. Access to this platform is also available for one accompanying person, who must have the same type of ticket."],
              es: ["Sí, existe un ticket PMR con un cupo limitado para aquellas personas que se desplazan en silla de ruedas. El acceso a esta plataforma también está habilitado para un acompañante, que deberá tener el mismo tipo de entrada."],
              ca: ["Sí, existeix un ticket PMR amb un cupo limitat per a aquelles persones que es desplacen en cadira de rodes. L'accés a aquesta plataforma també està habilitat per a un acompanyant, que haurà de tenir el mateix tipus d'entrada."]
            }
          },
          {
            title: {
              en: "Will there be places to eat?",
              es: "¿Habrá sitios para comer?",
              ca: "Hi haurà llocs per menjar?"
            },
            points: {
              en: ["Yes, there is a food truck area inside the venue."],
              es: ["Sí, dentro del recinto hay una zona de Food Trucks."],
              ca: ["Sí, dins del recinte hi ha una zona de Food Trucks."]
            }
          },
          {
            title: {
              en: "Designated smoking area",
              es: "Area habilitada para fumar",
              ca: "Àrea habilitada per fumar"
            },
            points: {
              en: ["There will be an outdoor area where you can go to smoke without having to leave the venue."],
              es: ["Habrá un espacio al aire libre, donde podrás salir a fumar sin tener que salir del recinto."],
              ca: ["Hi haurà un espai a l'aire lliure, on podràs sortir a fumar sense haver de sortir del recinte."]
            }
          },
          {
            title: {
              en: "Hydration points",
              es: "Puntos de hidratación",
              ca: "Punts d'hidratació"
            },
            points: {
              en: ["There will be hydration points located inside the venue."],
              es: ["Habrá un punto de hidratación en el interior del recinto."],
              ca: ["Hi haurà un punt d'hidratació a l'interior del recinte."]
            }
          },
          {
            title: {
              en: "PMR platform",
              es: "Plataforma PMR",
              ca: "Plataforma PMR"
            },
            points: {
              en: ["Located next to the FOH, it has limited capacity and only for those who have acquired a PMR ticket."],
              es: ["Situada junto al FOH, es de aforo limitado y solo para aquellos que hayan adquirido una entrada PMR."],
              ca: ["Situada al costat del FOH, és d'aforament limitat i només per a aquells que hagin adquirit una entrada PMR."]
            }
          },
          {
            title: {
              en: "Lockers",
              es: "Lockers",
              ca: "Taquilles"
            },
            points: {
              en: [
                "Located behind the main entrance, you can reserve a locker now to ensure you can store your belongings safely. The lockers are equipped with USB ports.",
                "https://primaverasound.app.mobilelocker.eu/event/1089/location"
              ],
              es: [
                "Situados tras el acceso principal, puedes reservar ya un locker para tener asegurado guardar tus pertenencias. Los lockers están equipados con enchufe USB.",
                "https://primaverasound.app.mobilelocker.eu/event/1089/location"
              ],
              ca: [
                "Situats darrere l'accés principal, pots reservar ja un locker per tenir assegurat guardar les teves pertinences. Els lockers estan equipats amb endoll USB.",
                "https://primaverasound.app.mobilelocker.eu/event/1089/location"
              ]
            }
          },
          {
            title: {
              en: "WELSAFE Point",
              es: "Punto de WELSAFE",
              ca: "Punt de WELSAFE"
            },
            points: {
              en: ["WELSafe CIC is a community-based non-profit organisation dedicated to harm reduction, education and wellbeing in the nightlife sector and beyond."],
              es: ["WELSafe CIC es una organización sin fines de lucro de interés comunitario dedicada a la reducción de daños, la educación y el bienestar en el sector nocturno y más allá."],
              ca: ["WELSafe CIC és una organització sense ànim de lucre d'interès comunitari dedicada a la reducció de danys, l'educació i el benestar en el sector nocturn i més enllà."]
            }
          }
        ]
      },
      fullWidth: true
    },
    {
      id: "buy",
      number: "02",
      title: {
        en: "My tickets",
        es: "Mis tickets",
        ca: "Els meus tiquets"
      },
      description: {
        en: "What happens next",
        es: "Qué pasa después",
        ca: "Què passa després"
      },
      content: {
        intro: {
          en: "Your tickets are now secured. Here's what you need to know:",
          es: "Tus entradas están ahora aseguradas. Esto es lo que necesitas saber:",
          ca: "Les teves entrades estan ara assegurades. Això és el que necessites saber:"
        },
        sections: [
          {
            title: {
              en: "Your Ticket Information",
              es: "Información de tu Entrada",
              ca: "Informació de la teva Entrada"
            },
            points: {
              en: [
                "Owner data is automatically attached to your ticket",
                "Each ticket carries the validation information of all attendees",
                "QR codes will be visible on the day of the event",
                "No screenshots will be accepted at the entrance",
              ],
              es: [
                "Los datos del propietario se adjuntan automáticamente a tu entrada",
                "Cada entrada lleva la información de validación de todos los asistentes",
                "Los códigos QR serán visibles el día del evento",
                "No se aceptarán capturas de pantalla en la entrada",
              ],
              ca: [
                "Les dades del propietari s'adjunten automàticament a la teva entrada",
                "Cada entrada porta la informació de validació de tots els assistents",
                "Els codis QR seran visibles el dia de l'esdeveniment",
                "No s'acceptaran captures de pantalla a l'entrada",
              ]
            },
          },
          {
            title: {
              en: "Multiple Tickets? Each One Needs Validation!",
              es: "¿Múltiples entradas? ¡Cada Una Necesita Validación!",
              ca: "Múltiples entrades? Cada Una Necessita Validació!"
            },
            points: {
              en: [
                "Each additional ticket requires validation",
                "You'll need to provide companion data for each ticket: Name, Email, Age, Country and Selfie",
                "Only tickets with complete validation can access the sale",
              ],
              es: [
                "Cada entrada adicional requiere validación",
                "Necesitarás proporcionar datos de acompañante para cada entrada: Nombre, Email, Edad, País y Selfie",
                "Solo las entradas con validación completa pueden acceder a la venta",
              ],
              ca: [
                "Cada entrada addicional requereix validació",
                "Necessitaràs proporcionar dades d'acompanyant per a cada entrada: Nom, Email, Edat, País i Selfie",
                "Només les entrades amb validació completa poden accedir a la venda",
              ]
            },
          },
          {
            title: {
              en: "Ticket Management",
              es: "Gestión de Entradas",
              ca: "Gestió d'Entrades"
            },
            points: {
              en: [
                "View all your tickets in the AccessTicket app",
                "Each ticket shows validation status",
                "Transfer or refund options (if available for the event)",
              ],
              es: [
                "Ve todas tus entradas en la app AccessTicket",
                "Cada entrada muestra el estado de validación",
                "Opciones de transferencia o reembolso (si están disponibles para el evento)",
              ],
              ca: [
                "Veu totes les teves entrades a l'app AccessTicket",
                "Cada entrada mostra l'estat de validació",
                "Opcions de transferència o reemborsament (si estan disponibles per a l'esdeveniment)",
              ]
            },
          },
        ],
      },
      image: 'https://assets.primaverasound.com/psweb/woggtwqh3gpm1cehndxi_1760084539202.png'
    },
    {
      id: "waitlist",
      number: "03",
      title: {
        en: "Can't Attend? Official Resale",
        es: "¿No Puedes Asistir? Reventa Oficial",
        ca: "No Pots Assistir? Revenda Oficial"
      },
      description: {
        en: "Safe ticket resale system",
        es: "Sistema de reventa seguro de entradas",
        ca: "Sistema de revenda segur d'entrades"
      },
      content: {
        intro: {
          en: "If you can't attend the event, you can safely resell your ticket through AccessTicket's official resale system.",
          es: "Si no puedes asistir al evento, puedes revender tu entrada de forma segura a través del sistema de reventa oficial de AccessTicket.",
          ca: "Si no pots assistir a l'esdeveniment, pots revendre la teva entrada de forma segura a través del sistema de revenda oficial d'AccessTicket."
        },
        sections: [
          {
            title: {
              en: "Requirements to Sell Your Ticket",
              es: "Requisitos para Vender tu Entrada",
              ca: "Requisits per Vendre la teva Entrada"
            },
            points: {
              en: [
                "Ticket must be validated in the AccessTicket app",
                "Must not have entered the event",
                "Add bank account (IBAN or PayPal) to your AccessTicket profile",
              ],
              es: [
                "La entrada debe estar validada en la app AccessTicket",
                "No debe haber entrado al evento",
                "Añadir cuenta bancaria (IBAN o PayPal) a tu perfil de AccessTicket",
              ],
              ca: [
                "L'entrada ha d'estar validada a l'app AccessTicket",
                "No ha d'haver entrat a l'esdeveniment",
                "Afegir compte bancari (IBAN o PayPal) al teu perfil d'AccessTicket",
              ]
            },
          },
          {
            title: {
              en: "How Selling Works",
              es: "Cómo Funciona la Venta",
              ca: "Com Funciona la Venda"
            },
            points: {
              en: [
                "Open AccessTicket app and open your ticket",
                'Select "Sell Ticket" option',
                "Your ticket gets listed on the waitlist",
                "Ticket is blocked while buyers are notified",
                "You can cancel anytime if no buyer is in purchase process",
              ],
              es: [
                "Abre la app AccessTicket y abre tu entrada",
                'Selecciona la opción "Vender Entrada"',
                "Tu entrada se lista en la lista de espera",
                "La entrada se bloquea mientras se notifica a los compradores",
                "Puedes cancelar en cualquier momento si no hay comprador en proceso de compra",
              ],
              ca: [
                "Obre l'app AccessTicket i obre la teva entrada",
                'Selecciona l\'opció "Vendre Entrada"',
                "La teva entrada es llista a la llista d'espera",
                "L'entrada es bloqueja mentre es notifica als compradors",
                "Pots cancel·lar en qualsevol moment si no hi ha comprador en procés de compra",
              ]
            },
          },
          {
            title: {
              en: "Payment Details",
              es: "Detalles de Pago",
              ca: "Detalls de Pagament"
            },
            points: {
              en: [
                "You'll receive the original ticket price (minus handling fees)",
                "Payment within 15-21 business days after sale",
                "PayPal payments have an additional 2% fee",
                "AccessTicket adds a small commercial margin to encourage sales",
              ],
              es: [
                "Recibirás el precio original de la entrada (menos comisiones de gestión)",
                "Pago dentro de 15-21 días hábiles después de la venta",
                "Los pagos de PayPal tienen una comisión adicional del 2%",
                "AccessTicket añade un pequeño margen comercial para fomentar las ventas",
              ],
              ca: [
                "Rebràs el preu original de l'entrada (menys comissions de gestió)",
                "Pagament dins de 15-21 dies hàbils després de la venda",
                "Els pagaments de PayPal tenen una comissió addicional del 2%",
                "AccessTicket afegeix un petit marge comercial per fomentar les vendes",
              ]
            },
          },
          {
            title: {
              en: "How Buying from Waitlist Works",
              es: "Cómo Funciona Comprar de la Lista de Espera",
              ca: "Com Funciona Comprar de la Llista d'Espera"
            },
            points: {
              en: [
                "Register on AccessTicket",
                'Join the "Waitlist" for the event',
                "Get notified when tickets become available (app + email)",
                "Limited time to purchase",
                "Complete payment to secure the ticket",
                "Check the Waitlist [terms and conditions here](https://www.primaverasound.com/es/terms-and-conditions-waitlist-marketplace)",
              ],
              es: [
                "Regístrate en AccessTicket",
                'Únete a la "Lista de Espera" del evento',
                "Recibe notificaciones cuando las entradas estén disponibles (app + email)",
                "Tiempo limitado para comprar (7 minutos a 4 horas)",
                "Completa el pago para asegurar la entrada",
                "Consulta los [términos y condiciones de la Lista de Espera aquí](https://www.primaverasound.com/es/terms-and-conditions-waitlist-marketplace)",
              ],
              ca: [
                "Registra't a AccessTicket",
                'Uneix-te a la "Llista d\'Espera" de l\'esdeveniment',
                "Rep notificacions quan les entrades estiguin disponibles (app + email)",
                "Temps limitat per comprar (7 minuts a 4 hores)",
                "Completa el pagament per assegurar l'entrada",
                "Consulta els [termes i condicions de la Llista d'Espera aquí](https://www.primaverasound.com/es/terms-and-conditions-waitlist-marketplace)",
              ]
            },
          },
        ],
        warning: {
          en: "Important Resale Rules",
          es: "Reglas Importantes de Reventa",
          ca: "Regles Importants de Revenda"
        },
        warningDetails: {
          en: [
            "Resale outside this official system is strictly prohibited",
            "Unofficial tickets may be cancelled without refund",
            "Once sold, tickets cannot be recovered",
            "Transaction fees are paid by the buyer",
            "You can withdraw your ticket from sale anytime (unless buyer is already purchasing)",
          ],
          es: [
            "La reventa fuera de este sistema oficial está estrictamente prohibida",
            "Las entradas no oficiales pueden ser canceladas sin reembolso",
            "Una vez vendidas, las entradas no se pueden recuperar",
            "Las comisiones de transacción las paga el comprador",
            "Puedes retirar tu entrada de la venta en cualquier momento (a menos que el comprador ya esté comprando)",
          ],
          ca: [
            "La revenda fora d'aquest sistema oficial està estrictament prohibida",
            "Les entrades no oficials poden ser cancel·lades sense reemborsament",
            "Un cop venudes, les entrades no es poden recuperar",
            "Les comissions de transacció les paga el comprador",
            "Pots retirar la teva entrada de la venda en qualsevol moment (tret que el comprador ja estigui comprant)",
          ]
        },
      },
      image: 'https://assets.primaverasound.com/psweb/o5r39s2qoxotdokzl53a_1760084589219.png'
    },
    {
      id: "how-to-get-there",
      number: "04",
      title: {
        en: "How to get there?",
        es: "¿Cómo llegar?",
        ca: "Com arribar-hi?"
      },
      description: {
        en: "Transport options to the venue",
        es: "Opciones de transporte al recinto",
        ca: "Opcions de transport al recinte"
      },
      content: {
        intro: {
          en: "Explore all transport options to make your journey to and from the event easier",
          es: "Explora todas las opciones de transporte para facilitar tu camino de ida y vuelta al evento",
          ca: "Explora totes les opcions de transport per facilitar el teu camí d'anada i tornada a l'esdeveniment"
        },
        sections: [
          {
            title: {
              en: "Metro",
              es: "Metro",
              ca: "Metro"
            },
            points: {
              en: ["Metro L8 Feria de Madrid"],
              es: ["Metro L8 Feria de Madrid"],
              ca: ["Metro L8 Feria de Madrid"]
            }
          },
          {
            title: {
              en: "Renfe Commuter Train",
              es: "Cercanías Renfe",
              ca: "Rodalies Renfe"
            },
            points: {
              en: ["The nearest station is Valdebebas, LC-1"],
              es: ["La estación más próxima es Valdebebas, LC-1"],
              ca: ["L'estació més propera és Valdebebas, LC-1"]
            }
          },
          {
            title: {
              en: "Bus Lines",
              es: "Líneas de Autobús",
              ca: "Línies d'Autobús"
            },
            points: {
              en: [
                "The following bus lines stop at IFEMA:",
                "➢ Line 73: Diego de León-Feria de Madrid (EMT).",
                "➢ Line 112: Mar de Cristal – Bo Aeropuerto (EMT).",
                "➢ Line 122: Avda. de América-Feria de Madrid (EMT).",
                "➢ Line SE-709: Feria de Madrid – Hospital Enfermera Isabel Zendal (EMT).",
                "It runs from 7:00 a.m. to 11:00 p.m.",
                "➢ Night lines N-3: Cibeles-Feria de Madrid (EMT) and N2: Cibeles-Valdebebas. The N2 is rarely used, as the stops at Gta. Isidro González Velázquez and Av. Juan Antonio Samaranch with Gta. Antonio Perpiñá are approximately 3 km away.",
                "➢ Line 828: Universidad Autónoma – Alcobendas – Canillejas - Feria de Madrid (Interurbano)."
              ],
              es: [
                "Las líneas de autobuses que tienen una parada en IFEMA son las siguientes:",
                "➢ Línea 73: Diego de León-Feria de Madrid (EMT).",
                "➢ Línea 112: Mar de Cristal – Bo Aeropuerto (EMT).",
                "➢ Línea 122: Avda. de América-Feria de Madrid (EMT).",
                "➢ Línea SE-709: Feria de Madrid – Hospital Enfermera Isabel Zendal (EMT).",
                "Circula de 7:00 a 23:00 horas.",
                "➢ Líneas nocturnas N-3: Cibeles-Feria de Madrid (EMT) y N2: Cibeles-Valdebebas. La N2, su uso es residual ya que las paradas que se encuentran en Gta. Isidro González Velázquez y Av. Juan Antonio Samaranch con Gta. Antonio Perpiñá se encuentran a 3 km de distancia aproximadamente.",
                "➢ Línea 828: Universidad Autónoma – Alcobendas – Canillejas - Feria de Madrid (Interurbano)."
              ],
              ca: [
                "Les línies d'autobusos que tenen una parada a IFEMA són les següents:",
                "➢ Línia 73: Diego de León-Feria de Madrid (EMT).",
                "➢ Línia 112: Mar de Cristal – Bo Aeropuerto (EMT).",
                "➢ Línia 122: Avda. de América-Feria de Madrid (EMT).",
                "➢ Línia SE-709: Feria de Madrid – Hospital Enfermera Isabel Zendal (EMT).",
                "Circula de 7:00 a 23:00 hores.",
                "➢ Línies nocturnes N-3: Cibeles-Feria de Madrid (EMT) i N2: Cibeles-Valdebebas. La N2, el seu ús és residual ja que les parades que es troben a Gta. Isidro González Velázquez i Av. Juan Antonio Samaranch amb Gta. Antonio Perpiñá es troben a 3 km de distància aproximadament.",
                "➢ Línia 828: Universidad Autónoma – Alcobendas – Canillejas - Feria de Madrid (Interurbano)."
              ]
            }
          },
          {
            title: {
              en: "Taxi",
              es: "Taxi",
              ca: "Taxi"
            },
            points: {
              en: [
                "There are three taxi ranks:",
                "Avenida del Partenón, opposite the main entrance to IFEMA",
                "Avenida de la Capital de España, numbers 4 and 6"
              ],
              es: [
                "Taxi encuentras 3 paradas:",
                "Avenida del Partenón, frente al acceso principal de IFEMA",
                "Avenida de la Capital de España, números 4 y 6"
              ],
              ca: [
                "Taxi trobes 3 parades:",
                "Avenida del Partenón, davant l'accés principal d'IFEMA",
                "Avenida de la Capital de España, números 4 i 6"
              ]
            }
          },
          {
            title: {
              en: "VTC",
              es: "VTC",
              ca: "VTC"
            },
            points: {
              en: ["VTC have a pick-up and drop-off point for passengers on Calle Turín"],
              es: ["VTC dispone de punto de recogida y bajada de viajeros en la calle Turín"],
              ca: ["VTC disposa de punt de recollida i baixada de viatgers al carrer Turín"]
            }
          },
          {
            title: {
              en: "BiciMAD",
              es: "BiciMAD",
              ca: "BiciMAD"
            },
            points: {
              en: ["BiciMAD has two stations on Avenida del Partenón, numbers 6 and 18"],
              es: ["BiciMAD tiene dos estaciones en la avenida del Partenón, número 6 y 18"],
              ca: ["BiciMAD té dues estacions a l'avinguda del Partenón, número 6 i 18"]
            }
          }
        ]
      },
      image: "https://assets.primaverasound.com/psweb/hc1piz6cllopoix13sn1_1760434613618.png"
    },
    {
      id: "ifema-pavilion",
      number: "05",
      title: {
        en: "IFEMA Pavilon 6",
        es: "IFEMA Pabellón 6",
        ca: "IFEMA Pavelló 6"
      },
      description: {
        en: "Venue access information",
        es: "Información de acceso al recinto",
        ca: "Informació d'accés al recinte"
      },
      content: {
        intro: {
          en: "To get to IFEMA Pavilion 6, you must cross the outdoor esplanade of Pavilion 2 and go to the general access area with your AccessTicket QR code ready on your mobile phone.",
          es: "Para llegar al Pabellón 6 de IFEMA deberás atravesar la explanada exterior del Pabellón 2 y dirigirte a la zona de acceso general con tu QR de AccessTicket preparado en tu móvil.",
          ca: "Per arribar al Pavelló 6 d'IFEMA hauràs de travessar l'esplanada exterior del Pavelló 2 i dirigir-te a la zona d'accés general amb el teu QR d'AccessTicket preparat al teu mòbil."
        }
      },
      image: "https://assets.primaverasound.com/psweb/ry1ro6gytpde7uhhvn4b_1760434668637.png"
    },
    {
      id: "allowed-prohibited-items",
      number: "06",
      title: {
        en: "Allowed / Prohibited Items",
        es: "Objetos permitidos / prohibidos",
        ca: "Objectes permesos / prohibits"
      },
      description: {
        en: "What you can and cannot bring",
        es: "Qué puedes y no puedes traer",
        ca: "Què pots i no pots portar"
      },
      content: {
        intro: {
          en: "Please review the list of allowed and prohibited items before attending the event.",
          es: "Por favor revisa la lista de objetos permitidos y prohibidos antes de asistir al evento.",
          ca: "Si us plau revisa la llista d'objectes permesos i prohibits abans d'assistir a l'esdeveniment."
        },
        sections: [
          {
            title: {
              en: "Allowed",
              es: "Permitidos",
              ca: "Permesos"
            },
            points: {
              en: [
                "Water bottle (without cap, -50CL.)",
                "Fanny pack",
                "Small backpacks (-24L.)",
                "Reusable plastic cup (40CL.)",
                "Sandwiches/Snacks",
                "Small bag"
              ],
              es: [
                "Botella de agua (sin tapón, -50CL.)",
                "Riñonera",
                "Mochilas pequeñas (-24L.)",
                "Vaso reutilizable de plástico (40CL.)",
                "Bocadillos/Snacks",
                "Bolso pequeño"
              ],
              ca: [
                "Ampolla d'aigua (sense tap, -50CL.)",
                "Ronyonera",
                "Motxilles petites (-24L.)",
                "Got reutilitzable de plàstic (40CL.)",
                "Entrepans/Snacks",
                "Bossa petita"
              ]
            }
          },
          {
            title: {
              en: "Prohibited",
              es: "Prohibidos",
              ca: "Prohibits"
            },
            points: {
              en: [
                "Motorcycle helmet",
                "Suitcases/Backpacks +24L",
                "Metal, glass or blunt objects",
                "Frozen containers",
                "Banners and/or flags that incite violence",
                "Spray",
                "Alcohol/Drugs",
                "Selfie sticks, umbrellas, drones and laser pointers",
                "Cooler or bag with lots of food",
                "Cameras and audio recorders",
                "Weapons/Firecrackers"
              ],
              es: [
                "Casco de moto",
                "Maletas/Mochilas +24L",
                "Objetos de metal, cristal u objetos contundentes",
                "Envases congelados",
                "Pancartas y/o banderas que inciden a la violencia",
                "Spray",
                "Alcohol/Drogas",
                "Palos selfie, paraguas, drones y punteros láser",
                "Nevera o bolsa con mucha comida",
                "Cámaras y grabadoras de audio",
                "Armas/Petados"
              ],
              ca: [
                "Casc de moto",
                "Maletes/Motxilles +24L",
                "Objectes de metall, cristall o objectes contundents",
                "Envasos congelats",
                "Pancartes i/o banderes que incideixen a la violència",
                "Spray",
                "Alcohol/Drogues",
                "Pals selfie, paraigües, drons i punters làser",
                "Nevera o bossa amb molta menjar",
                "Càmeres i gravadores d'àudio",
                "Armes/Petards"
              ]
            }
          }
        ]
      },
      image: "https://assets.primaverasound.com/psweb/05bz9v2dbwrw21n1ntyr_1760434826599.png"
    }
  ]
};
